export type { ArticleDetail } from './types';

import { gamingMonitorsArticle } from './gaming-monitors';
import { streamingMicrophonesArticle } from './streaming-microphones';
import { mechanicalKeyboardsArticle } from './mechanical-keyboards';
import { productivityMonitorsArticle } from './productivity-monitors';
import { gamingMouseArticle } from './gaming-mouse';
import { gamingHeadsetArticle } from './gaming-headset';
import { webcamArticle } from './webcam';
import { ergonomicChairsArticle } from './ergonomic-chairs';
import { gamingDesksArticle } from './gaming-desks';
import type { ArticleDetail } from './types';

export const articleDetails: Record<string, ArticleDetail> = {
  [gamingMonitorsArticle.slug]: gamingMonitorsArticle,
  [streamingMicrophonesArticle.slug]: streamingMicrophonesArticle,
  [mechanicalKeyboardsArticle.slug]: mechanicalKeyboardsArticle,
  [productivityMonitorsArticle.slug]: productivityMonitorsArticle,
  [gamingMouseArticle.slug]: gamingMouseArticle,
  [gamingHeadsetArticle.slug]: gamingHeadsetArticle,
  [webcamArticle.slug]: webcamArticle,
  [ergonomicChairsArticle.slug]: ergonomicChairsArticle,
  [gamingDesksArticle.slug]: gamingDesksArticle,
};
